import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, ButtonGroup, UncontrolledButtonDropdown } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getCivilAccountCategory as onGetCivilAccountCategorys, addNewCivilAccountCategory as onAddNewCivilAccountCategory, updateCivilAccountCategory as onUpdateCivilAccountCategory, deleteCivilAccountCategory as onDeleteCivilAccountCategory, getCivilAccountCategoryLoading, resetCivilAccountCategoryState } from "../../../store/civilAccountCategory/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";

const BudgetAccountCategory = () => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const [pageIdx, setPageIdx] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, branches, branchLoading, positions, civilAccountCategories, isCivilAccountCategoryCreated, isCivilAccountCategorySuccess, loading, error, brands, brandLoading, companies, companyLoading, clientLoading, clients } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    civilAccountCategories: state.CivilAccountCategory.civilAccountCategories,
    isCivilAccountCategoryCreated: state.CivilAccountCategory.isCivilAccountCategoryCreated,
    isCivilAccountCategorySuccess: state.CivilAccountCategory.isCivilAccountCategorySuccess,
    loading: state.CivilAccountCategory.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    error: state.CivilAccountCategory.error,
    positions: state.Position.positions,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
  }));

  const [civilAccountCategoryList, setCivilAccountCategoryList] = useState([]);
  const [civilAccountCategory, setCivilAccountCategory] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchSearchList, setBranchSearchList] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const typeSelectData = [
    {
      options: [
        { label: "INFRASTRUKTUR", value: "INFRASTRUKTUR" },
        { label: "BANGUNAN", value: "BANGUNAN" },
        { label: "UPAH", value: "UPAH" },
        { label: "PROGRESS BANGUNAN", value: "PROGRESS BANGUNAN" },
        { label: "PEKERJAAN TAMBAH 1", value: "PEKERJAAN TAMBAH 1" },
        { label: "PEKERJAAN TAMBAH 2", value: "PEKERJAAN TAMBAH 2" },
        { label: "PEKERJAAN TAMBAH 3", value: "PEKERJAAN TAMBAH 3" },
        { label: "PEKERJAAN TAMBAH 4", value: "PEKERJAAN TAMBAH 4" },
        { label: "PEKERJAAN TAMBAH 5", value: "PEKERJAAN TAMBAH 5" },
        { label: "PEKERJAAN TAMBAH 6", value: "PEKERJAAN TAMBAH 6" },
        { label: "PEKERJAAN TAMBAH 7", value: "PEKERJAAN TAMBAH 7" },
        { label: "PEKERJAAN TAMBAH 8", value: "PEKERJAAN TAMBAH 8" },
        { label: "LISTRIK JARINGAN", value: "LISTRIK JARINGAN" },
      ],
    },
  ];

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [civilAccountCategoryFiles, setCivilAccountCategoryFiles] = useState([]);
  const [printDoc, setPrintDoc] = useState([]);

  useEffect(() => {
    if (branchSelected && companySelected) {
      setSearchValue("");
      dispatch(onGetCivilAccountCategorys({ branchId: branchSelected?.value ?? "" }));
    }
  }, [companySelected, branchSelected]);

  const onClickDelete = (civilAccountCategory) => {
    setCivilAccountCategory(civilAccountCategory);
    setDeleteModal(true);
  };

  const handleDeleteCivilAccountCategory = () => {
    if (civilAccountCategory) {
      dispatch(onDeleteCivilAccountCategory(civilAccountCategory));
      setDeleteModal(false);
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = civilAccountCategoryFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setCivilAccountCategoryFiles(newState);
    } else {
      const index = civilAccountCategoryFiles.findIndex((fl) => fl.filename === file.filename);

      setCivilAccountCategoryFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    if (!isEmpty(civilAccountCategoryList)) {
      let arr = [];
      civilAccountCategoryList.forEach((asset) => {
        arr.push({ value: asset.id, label: asset.name });
      });
    }
  }, [civilAccountCategoryList]);

  useEffect(() => {
    setPositionList(positions);
  }, [positions]);

  useEffect(() => {
    if (!isEmpty(civilAccountCategories)) {
      let filteredCivilAccountCategorys = civilAccountCategories;
      if (activeTypeTab !== "all") {
        filteredCivilAccountCategorys = civilAccountCategories.filter((civilAccountCategory) => {
          return civilAccountCategory.cvl_account_cat_status.name === activeTypeTab;
        });
      }
      setCivilAccountCategoryList(filteredCivilAccountCategorys.map((el) => ({ ...el, isChecked: false })));
    }
  }, [civilAccountCategories]);

  // Nama	Induk	Jenis Anggaran	Cabang	Urutan	Keterangan	Status
  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "cvl_account_cat_parent",
        label: "Induk",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis Anggaran",
        isSelected: true,
        data: [],
      },
      {
        id: "cvl_account_cat_branch",
        label: "Cabang",
        isSelected: true,
        data: [],
      },
      {
        id: "sort_order",
        label: "Urutan",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (civilAccountCategoryList.length > 0) {
      civilAccountCategoryList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "cvl_account_cat_parent" || doc.id === "cvl_account_cat_branch") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [civilAccountCategoryList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredCivilAccountCategorys = civilAccountCategories;
      if (type !== "all") {
        filteredCivilAccountCategorys = civilAccountCategories.filter((civilAccountCategory) => {
          return civilAccountCategory.cvl_account_cat_status.name === type;
        });
      }
      setCivilAccountCategoryList(filteredCivilAccountCategorys);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  // useEffect(() => {
  //   if (!isEmpty(civilAccountCategories)) {
  //     setCivilAccountCategoryList(civilAccountCategories);
  //   }
  // }, [civilAccountCategories]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  // useEffect(() => {
  //   if (!isEmpty(civilAccountCategories)) {
  //     var data = [];
  //     var opt = [];
  //     civilAccountCategories.forEach((item, key) => {
  //       const name = item.name;
  //       const id = item.id;
  //       var obj = { label: name, value: id };
  //       opt.push(obj);
  //     });
  //     var option = { options: opt };
  //     data.push(option);
  //     setParentList(data);
  //   }
  // }, [civilAccountCategories]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    let dataSearch = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    var optionSearch = { options: [{ label: "Semua Cabang", value: "" }, ...opt] };
    data.push(option);
    dataSearch.push(optionSearch);

    if (branches.length > 0) {
      setBranchList(data);
      setBranchSearchList(dataSearch);
    }
  }, [branches]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCivilAccountCategory(null);
      setCivilAccountCategoryFiles([]);
      setParentList([]);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleCivilAccountCategoryClick = useCallback(
    (arg, isCopy) => {
      const civilAccountCategory = arg;
      setCivilAccountCategory({
        id: civilAccountCategory.id,
        name: civilAccountCategory.name,
        image: civilAccountCategory.image,
        code: civilAccountCategory.code,
        description: civilAccountCategory.description,
        sortOrder: civilAccountCategory.sort_order,
        type: {
          label: civilAccountCategory.type,
          value: civilAccountCategory.type,
        },
        client:
          civilAccountCategory.cvl_account_cat_client == null
            ? ""
            : {
                label: civilAccountCategory.cvl_account_cat_client.name,
                value: civilAccountCategory.cvl_account_cat_client.id,
              },
        company:
          civilAccountCategory.cvl_account_cat_company == null
            ? ""
            : {
                label: civilAccountCategory.cvl_account_cat_company.name,
                value: civilAccountCategory.cvl_account_cat_company.id,
              },
        branch:
          civilAccountCategory.cvl_account_cat_branch == null
            ? ""
            : {
                label: civilAccountCategory.cvl_account_cat_branch.name,
                value: civilAccountCategory.cvl_account_cat_branch.id,
              },
        status:
          civilAccountCategory.cvl_account_cat_status == null
            ? ""
            : {
                label: civilAccountCategory.cvl_account_cat_status.name,
                value: civilAccountCategory.cvl_account_cat_status.id,
              },
      });

      setIsEdit(isCopy);
      toggle();
    },
    [toggle]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (civilAccountCategory && civilAccountCategory.client) || clientSelected,
      company: (civilAccountCategory && civilAccountCategory.company) || companySelected,
      branch: (civilAccountCategory && civilAccountCategory.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      name: (civilAccountCategory && civilAccountCategory.name) ?? "",
      code: (civilAccountCategory && civilAccountCategory.code) ?? "",
      status: (civilAccountCategory && civilAccountCategory.status) ?? "",
      description: (civilAccountCategory && civilAccountCategory.description) ?? "",
      parent: civilAccountCategory && civilAccountCategory.parent,
      sortOrder: (civilAccountCategory && civilAccountCategory.sortOrder) ?? "",
      type: (civilAccountCategory && civilAccountCategory.type) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),
    onSubmit: (values) => {
      dispatch(getCivilAccountCategoryLoading());
      if (isEdit) {
        const updateCivilAccountCategory = {
          id: civilAccountCategory ? civilAccountCategory.id : 0,
          companyId: values.company.value,
          clientId: values.client.value,
          branchId: values.branch.value,
          name: values.name,
          code: values.code,
          statusId: 2, //values.status.value,
          description: values.description,
          parentId: values.parent ? values.parent.value : null,
          sort_order: values.sortOrder,
          type: values.type.value,
        };
        dispatch(onUpdateCivilAccountCategory(updateCivilAccountCategory));
        validation.resetForm();
      } else {
        const newCivilAccountCategory = {
          companyId: values.company.value,
          clientId: values.client.value,
          branchId: values.branch.value,
          name: values.name,
          code: values.code,
          statusId: 2, //values.status.value,
          description: values.description,
          parentId: values.parent ? values.parent.value : null,
          sort_order: values.sortOrder,
          type: values.type.value,
        };
        dispatch(onAddNewCivilAccountCategory(newCivilAccountCategory));
        validation.resetForm();
      }
      toggle();
    },
  });

  // const checkedAll = () => {
  //   const checkall = document.getElementById("checkBoxAll");
  //   const ele = document.querySelectorAll(".dataCheckbox");

  //   if (checkall.checked) {
  //     ele.forEach((ele) => {
  //       ele.checked = true;
  //     });
  //   } else {
  //     ele.forEach((ele) => {
  //       ele.checked = false;
  //     });
  //   }
  // };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCivilAccountCategory(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = civilAccountCategoryList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setCivilAccountCategoryList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = civilAccountCategoryList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setCivilAccountCategoryList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("createCivilAccountCategory") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleCivilAccountCategoryClick(data, false);
                    }}
                  >
                    <i className="ri-file-copy-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateCivilAccountCategory") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleCivilAccountCategoryClick(data, true);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteCivilAccountCategory") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
        Cell: (cell) => {
          return <span className="fw-semibold"> {cell.value} </span>;
        },
      },
      {
        Header: "Induk",
        accessor: "cvl_account_cat_parent.name",
        filterable: true,
      },
      {
        Header: "Jenis Anggaran",
        accessor: "type",
        filterable: true,
        Cell: (data) => {
          let stat;
          let statName = data.row.original.type;
          switch (statName) {
            case "BANGUNAN":
              stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
              break;
            case "INFRASTRUKTUR":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            case "UPAH":
              stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
          }
          return <div className="hstack gap-2">{stat}</div>;
        },
      },
      {
        Header: "Cabang",
        accessor: "cvl_account_cat_branch.name",
        filterable: true,
      },
      // {
      //   Header: "Grup Usaha",
      //   accessor: "cvl_account_cat_client.name",
      //   filterable: true,
      // },
      {
        Header: "Urutan",
        accessor: "sort_order",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "cvl_account_cat_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [civilAccountCategoryList, handleCivilAccountCategoryClick, userRole, userType, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = civilAccountCategoryList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setCivilAccountCategoryList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => civilAccountCategoryList, [civilAccountCategoryList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const [searchBranch, setSearchBranch] = useState([]);

  function handleCivilAccountCategoryStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchSelected?.value ?? "",
    };
    dispatch(resetCivilAccountCategoryState());
    setCivilAccountCategoryList([]);
    dispatch(onGetCivilAccountCategorys(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setCivilAccountCategoryList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(onGetCivilAccountCategorys({ branchId: branchSelected?.value ?? "" }));
  }

  const handleGetParent = (id) => {
    var data = [];
    var opt = [];
    civilAccountCategories.forEach((item, key) => {
      if (item.branchId === id) {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      }
    });
    var option = { options: opt };
    data.push(option);

    if (opt.length > 0) {
      setParentList(data);
    } else {
      setParentList([]);
    }
  };

  document.title = "Kategori Anggaran | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={civilAccountCategoryList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCivilAccountCategory} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Teknik" pageTitle="Data Kategori Anggaran" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCivilAccountCategory") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setCivilAccountCategory("");
                setIsEdit(false);
                setCompanyList([]);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteCivilAccountCategory") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="civilAccountCategoryList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA KATEGORI
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Kategori Anggaran" : "Tambah Kategori Anggaran"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                dispatch(setClientSelect(e));
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                setBranchList([]);
                                validation.resetForm();
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Cabang&nbsp;
                              {branchLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Pilih Cabang"
                              onChange={(e) => {
                                setParentList([]);
                                validation.setFieldValue("parent", "");
                                validation.setFieldValue("branch", e);
                                handleGetParent(e.value);
                              }}
                              options={branchList}
                            ></Select>
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="brand" className="form-label">
                              Induk Kategori
                              {loading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="parent"
                              value={validation.values.parent}
                              placeholder="Pilih Induk kategori"
                              onChange={(e) => {
                                validation.setFieldValue("parent", e);
                              }}
                              options={parentList}
                              invalid={validation.touched.parent && validation.errors.parent ? true : false}
                            ></Select>
                            {validation.touched.parent && validation.errors.parent ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.parent}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="code-field" className="form-label">
                              Kode
                            </Label>
                            <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="sortOrder-field" className="form-label">
                              No Urut
                            </Label>
                            <Input name="sortOrder" id="sortOrder-field" className="form-control" placeholder="Isi No Urut" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sortOrder} invalid={validation.touched.sortOrder && validation.errors.sortOrder ? true : false} />
                            {validation.touched.sortOrder && validation.errors.sortOrder ? <FormFeedback type="invalid">{validation.errors.sortOrder}</FormFeedback> : null}
                          </div>
                          {/* <div className="mb-3">
                            <Label htmlFor="type-field" className="form-label">
                              Type
                            </Label>
                            <Input name="type" id="type-field" className="form-control" placeholder="Enter Type" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.type} invalid={validation.touched.type && validation.errors.type ? true : false} />
                            {validation.touched.type && validation.errors.type ? <FormFeedback type="invalid">{validation.errors.type}</FormFeedback> : null}
                          </div> */}
                          <div className="mb-3">
                            <Label htmlFor="type-field" className="form-label">
                              Jenis Anggaran
                            </Label>
                            <Select
                              name="type"
                              value={validation.values.type}
                              placeholder="Pilih Jenis Anggaran"
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={typeSelectData}
                            ></Select>
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="status-field" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              placeholder="Pilih Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              options={statusActiveData}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            setCompanyList([]);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Simpan Kategori"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BudgetAccountCategory;
